module.exports = __webpack_public_path__ + "img/jd.6407404e.png";